export enum ScheduleResourceType {
    Function = 'function',
    Execution = 'execution',
    Message = 'message',
    Backup = 'backup',
}
